(function($) {
	var instances = [];

	var Deferred = $.Deferred;

	function uuid() {
		return ++uuid._id;
	}
	uuid._id = 0;

	function collect(promises, context) {
		function gather() {
		  return Array.prototype.slice.call(arguments);
		};
	  var deferred = $.Deferred();
	  return $.when.apply(null, promises).then(gather).then(function() {
	    return deferred.resolveWith(context, arguments);
	  }, function() {
	    return deferred.rejectWith(context, arguments);
	  }).promise();
	};

	var loadImage = function(url) {
		var loader = function(deferred) {
			var image = new Image();

			function unbind() {
				image.onload = null;
				image.onerror = null;
			}

			image.onload = function() {
				unbind();
				deferred.resolve(image);
			}

			image.onerror = function() {
				unbind();
				deferred.reject(image);
			}
			image.src = url;
		}

		return Deferred(loader).promise();
	};

	function isNumber(n) {
	  return typeof n === 'number' && !isNaN(n);
	}

	function toArray(obj, offset) {
	  var args = [];

	  if (isNumber(offset)) { // It's necessary for IE8
	    args.push(offset);
	  }

	  return args.slice.apply(obj, args);
	};

	function isUndefined(n) {
	  return typeof n === 'undefined';
	};

	$.fn.imageSpinner = function(options) {
		var args = toArray(arguments, 1);
		var result;

		this.each(function() {
			var $container = $(this);
			var data = $container.data('image-spinner');
			var fn;

			if (!data) {
				var imageSpinner = new ImageSpinner($container, $.extend({}, options));
				$container.data('image-spinner', imageSpinner);
				var id = uuid();
				$container.data('image-spinner-uuid', id);
				instances[id] = imageSpinner;
			}

			if (typeof options === 'string' && $.isFunction((fn = data[options]))) {
				result = fn.apply(data, args);
			}
		});

		return isUndefined(result) ? this : result;
	};

	var ImageSpinner = function($container, options) {
		// Tells if the app is ready for user interaction
		this.ready = false;
		// Tells the app if the user is dragging the pointer
		this.dragging = false;
		// Stores the pointer starting X position for the pointer tracking
		this.pointerStartPosX = 0;
		// Stores the pointer ending X position for the pointer tracking
		this.pointerEndPosX = 0;
		// Stores the distance between the starting and ending pointer X position in each time period we are tracking the pointer
		this.pointerDistance = 0;

		// The starting time of the pointer tracking period
		this.monitorStartTime = 0;
		// The pointer tracking time duration
		this.monitorInt = 10;
		// A setInterval instance used to call the rendering function
		this.ticker = 0;
		// Sets the speed of the image sliding animation
		this.speedMultiplier = options.speedMultiplier || 10;

		// Stores the total amount of images we have in the sequence
		this.totalFrames = options.images.length;
		// The current frame value of the image slider animation
		this.currentFrame = 0;
		// Stores all the loaded image objects
		this.frames = [];
		// Stores all the image names.
		this.imageSources = [];
		// The value of the end frame which the currentFrame will be tweened to during the sliding animation
		this.endFrame = 0;
		// We keep track of the loaded images by increasing every time a new image is added to the image slider
		this.loadedImages = 0;

		// Caching DOM element references
		this.$document = $(document);
		this.$container = $container;
		this.$images = $container.find('.ImageSpinner-images');
		this.$loader = $container.find('.ImageSpinner-loader');

		// Initial spin demo vars
		this.demoMode = false;

		this.fakePointer = {
			x: 0,
			speed: 1
		};
		this.fakePointerTimer = 0;
		// loading the firt image in the sequence.
		this.loadImages(options.images);
		// this.loadImage();
		this.bindEvents();
	};

	ImageSpinner.prototype.setImages = function(images) {
		this.loadImages(images);
	};

	ImageSpinner.prototype.loadImages = function(images) {
		this.imageSources = images;
		var promises = this.imageSources.map(function(src) {
			return loadImage(src);
		});
		collect(promises, this).then(function(images) {
			this.renderImages(images);
			this.showThreesixty();
		});
	};

	/**
		* Creates a new <li> and loads the next image in the sequence inside it.
		* With jQuery we add the "load" event handler to the image, so when it's successfully loaded, we call the "imageLoaded" function.
		*/
	ImageSpinner.prototype.renderImages = function(images) {
		var $items = this.$images.find('li');
		this.stop();
		$items.addClass('is-expired');
		this.frames = [];
		images.forEach(function(image, index) {
			// Creates a new <li>
			var li = document.createElement("li");
			var $li = $(li);
			var $imageEl = $('<img class="ImageSpinner-image">')
				.attr('src', image.src)
				.appendTo(li);

			if (index === 0) {
				$items.removeClass('is-active');
				$li.addClass('is-active');
			}

			// We add the newly added image object (returned by jQuery) to the "frames" array.
			this.frames.push($li);
			// We add the <li> to the <ol>
			this.$images.append(li);
		}, this);
		$items.filter(function(_, img) { return $(img).hasClass('is-expired'); }).remove();
	};

	ImageSpinner.prototype.stop = function() {
		if (this.fakePointerTimer) {
			this.demoMode = true;
			window.clearInterval(this.fakePointerTimer);
		}

		if (this.ticker) {
			window.clearInterval(this.ticker);
			this.ticker = 0;
		}

		this.currentFrame = 0;
	};

	/**
	 * Displays the images with the "swooshy" spinning effect.
	 * As the endFrame is set to -720, the slider will take 4 complete spin before it stops.
	 * At this point it also sets the application to be ready for the user interaction.
	 */
	ImageSpinner.prototype.showThreesixty = function() {
		this.$images.show();
		// Sets the "ready" variable to true, so the app now reacts to user interaction
		this.ready = true;
		// ...so when the animation renders, it will initially take 4 complete spins.
		if(!this.demoMode) {
			this.refresh();
		} else {
			this.stop();
			this.fakePointerTimer = window.setInterval(this.moveFakePointer.bind(this), 150);
		}
	};

	/*
	* Moves the fake pointer, so that we can have some demo spinning until the user interferes with their pointer
	*/
	ImageSpinner.prototype.moveFakePointer = function() {
		this.fakePointer.x += this.fakePointer.speed;
		this.trackPointer();
	};

	/*
	* Stops the fake pointer moving and lets the user control the spinning
	*/
	ImageSpinner.prototype.quitDemoMode = function() {
		window.clearInterval(this.fakePointerTimer);
		this.demoMode = false;
	};

	/**
	 * Renders the image slider frame animations.
	 */
	ImageSpinner.prototype.render = function() {
		// The rendering function only runs if the "currentFrame" value hasn't reached the "endFrame" one
		if(this.currentFrame !== this.endFrame) {
			/*
				Calculates the 10% of the distance between the "currentFrame" and the "endFrame".
				By adding only 10% we get a nice smooth and eased animation.
				If the distance is a positive number, we have to ceil the value, if its a negative number, we have to floor it to make sure
				that the "currentFrame" value surely reaches the "endFrame" value and the rendering doesn't end up in an infinite loop.
			*/
			var frameEasing = this.endFrame < this.currentFrame ?
				Math.floor((this.endFrame - this.currentFrame) * 0.1) :
				Math.ceil((this.endFrame - this.currentFrame) * 0.1);
			// Sets the current image to be hidden
			this.hidePreviousFrame();
			// Increments / decrements the "currentFrame" value by the 10% of the frame distance
			this.currentFrame += frameEasing;
			// Sets the current image to be visible
			this.showCurrentFrame();
		} else {
			// If the rendering can stop, we stop and clear the ticker
			window.clearInterval(this.ticker);
			this.ticker = 0;
		}
	};

	/**
	 * Creates a new setInterval and stores it in the "ticker"
	 * By default I set the FPS value to 60 which gives a nice and smooth rendering in newer browsers
	 * and relatively fast machines, but obviously it could be too high for an older architecture.
	 */
	ImageSpinner.prototype.refresh = function() {
		// If the ticker is not running already...
		if (this.ticker === 0) {
			// Let's create a new one!
			this.ticker = setInterval(this.render.bind(this), Math.round(1000 / 60));
		}
	};

	/**
	* Hides the previous frame
	*/
	ImageSpinner.prototype.hidePreviousFrame = function() {
		/*
			Replaces the "current-image" class with the "previous-image" one on the image.
			It calls the "getNormalizedCurrentFrame" method to translate the "currentFrame" value to the "totalFrames" range (1-180 by default).
		*/
		this.frames[this.getNormalizedCurrentFrame()].removeClass("is-active");
	};


	/**
	* Displays the current frame
	*/
	ImageSpinner.prototype.showCurrentFrame = function() {
		/*
			Replaces the "current-image" class with the "previous-image" one on the image.
			It calls the "getNormalizedCurrentFrame" method to translate the "currentFrame" value to the "totalFrames" range (1-180 by default).
		*/
		this.frames[this.getNormalizedCurrentFrame()].addClass("is-active");
	};

	/**
	 * Returns the "currentFrame" value translated to a value inside the range of 0 and "totalFrames"
	 */
	ImageSpinner.prototype.getNormalizedCurrentFrame = function() {
		var c = -Math.ceil(this.currentFrame % this.totalFrames);
		if (c < 0) c += (this.totalFrames - 1);
		return c;
	};

	/**
	 * Returns a simple event regarding the original event is a mouse event or a touch event.
	 */
	ImageSpinner.prototype.getPointerEvent = function(event) {
		return event.originalEvent.targetTouches ? event.originalEvent.targetTouches[0] : event;
	};

	ImageSpinner.prototype.bindEvents = function() {
		/**
		 * Adds the jQuery "mousedown" event to the image slider wrapper.
		 */
		this.$container.on("mousedown", function(event) {
			this.quitDemoMode();

			// Prevents the original event handler behaciour
			// event.preventDefault();
			// Stores the pointer x position as the starting position
			this.pointerStartPosX = this.getPointerEvent(event).pageX;
			// Tells the pointer tracking function that the user is actually dragging the pointer and it needs to track the pointer changes
			this.dragging = true;
		}.bind(this));

		/**
		* Adds the jQuery "mouseup" event to the document. We use the document because we want to let the user to be able to drag
		* the mouse outside the image slider as well, providing a much bigger "playground".
		*/
		this.$document.on("mouseup", function(event){
			// Tells the pointer tracking function that the user finished dragging the pointer and it doesn't need to track the pointer changes anymore
			this.dragging = false;
		}.bind(this));

		/**
		* Adds the jQuery "mousemove" event handler to the document. By using the document again we give the user a better user experience
		* by providing more playing area for the mouse interaction.
		*/
		this.$document.on("mousemove", function (event){
			if (this.demoMode) {
				return;
			}

			// Prevents the original event handler behaciour
			// event.preventDefault();
			// Starts tracking the pointer X position changes
			this.trackPointer(event);
		}.bind(this));

		this.$container.on("touchstart", function(event) {
			this.quitDemoMode();

			// Prevents the original event handler behaciour
			// event.preventDefault();
			// Stores the pointer x position as the starting position
			this.pointerStartPosX = this.getPointerEvent(event).pageX;
			// Tells the pointer tracking function that the user is actually dragging the pointer and it needs to track the pointer changes
			this.dragging = true;
		}.bind(this));

		this.$container.on("touchmove", function (event) {
			// Starts tracking the pointer X position changes
			this.trackPointer(event);
		}.bind(this));

		this.$container.on("touchend", function (event) {
			// Tells the pointer tracking function that the user finished dragging the pointer and it doesn't need to track the pointer changes anymore
			this.dragging = false;
		}.bind(this));
	};

	/**
	 * Tracks the pointer X position changes and calculates the "endFrame" for the image slider frame animation.
	 * This function only runs if the application is ready and the user really is dragging the pointer; this way we can avoid unnecessary calculations and CPU usage.
	 */
	ImageSpinner.prototype.trackPointer = function(event) {
		var userDragging = this.ready && this.dragging ? true : false;
		var demoDragging = this.demoMode;

		if (userDragging || demoDragging) {

			// Stores the last x position of the pointer
			this.pointerEndPosX = userDragging ? this.getPointerEvent(event).pageX : this.fakePointer.x;

			// Checks if there is enough time past between this and the last time period of tracking
			if(this.monitorStartTime < new Date().getTime() - this.monitorInt) {
				// Calculates the distance between the pointer starting and ending position during the last tracking time period
				this.pointerDistance = this.pointerEndPosX - this.pointerStartPosX;
				if (this.pointerDistance === 0) {
					return true;
				}

				if (event) {
					event.preventDefault();
				}

				// Calculates the endFrame using the distance between the pointer X starting and ending positions and the "speedMultiplier" values
				this.endFrame = this.currentFrame +
					Math.ceil((this.totalFrames - 1) *
					this.speedMultiplier *
					(this.pointerDistance / this.$container.width()));

				// Updates the image slider frame animation
				this.refresh();
				// restarts counting the pointer tracking period
				this.monitorStartTime = new Date().getTime();
				// Stores the the pointer X position as the starting position (because we started a new tracking period)
				this.pointerStartPosX = userDragging ? this.getPointerEvent(event).pageX : this.fakePointer.x;
			}
		} else {
			return;
		}
	};

})(jQuery);